import { Chip, useTheme } from "@mui/material";
import { tokens } from "../../../../theme";
import AnimatedTable, { ColumnDef } from "../AnimatedTable";

const mockMaintenance = [
  { id: 1, issue: "LCD Replacement", date: "2026-06-20", status: "Resolved", technician: "John Doe", cost: "$100" },
  { id: 2, issue: "Battery Upgrade", date: "2026-07-15", status: "pending", technician: "Jane Smith", cost: "$150" },
  { id: 3, issue: "Screen Protector", date: "2026-08-05", status: "Resolved", technician: "Alice Johnson", cost: "$25" },
];

export default function MaintenanceTab() {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  const columns: ColumnDef<(typeof mockMaintenance)[0]>[] = [
    {
      key: "issue",
      label: "Issue",
      cellSx: { fontWeight: 500, color: colors.primary[700] },
      render: (row) => row.issue,
    },
    { key: "date", label: "Date", render: (row) => row.date },
    {
      key: "status",
      label: "Status",
      render: (row) => (
        <Chip
          label={row.status}
          size="small"
          sx={{
            bgcolor: row.status === "Resolved" ? "#e8f5e9" : "#fff3e0",
            color: row.status === "Resolved" ? "#2e7d32" : "#e65100",
            fontWeight: 600,
            borderRadius: "16px",
          }}
        />
      ),
    },
    { key: "technician", label: "Technician", render: (row) => row.technician },
    { key: "cost", label: "Cost", render: (row) => row.cost },
  ];

  return (
    <AnimatedTable
      columns={columns}
      rows={mockMaintenance}
      getRowId={(row) => row.id}
      page={0}
      totalPages={1}
      onPageChange={() => {}}
      emptyMessage="No maintenance records found."
    />
  );
}